import { useRef, useEffect } from 'react';

export const useInterval = (callback, delay, tickOnStart = false) => {
    const savedCallback = useRef();

    useEffect(() => {
        savedCallback.current = callback;
    });

    useEffect(() => {
        function tick() {
            savedCallback.current();
        }

        if (tickOnStart) {
            tick();
        }

        const id = setInterval(tick, delay);
        return () => clearInterval(id);
    }, [delay]);
};
